import { useEffect } from "react";

import useScheduledMaintenanceStore, { fetchScheduledMaintenance } from "./scheduledStore";

const useScheduledMaintenance = () => {
  const notice = useScheduledMaintenanceStore((state) => state.notice);

  useEffect(() => {
    fetchScheduledMaintenance();
  }, []);

  return notice;
};

export default useScheduledMaintenance;
